module.exports = __webpack_public_path__ + "static/media/factsMetaImage.4e06fdef.png";